export default "__VITE_ASSET__DBOFuRM7__"